import styled, { css } from 'styled-components';

export const Container = styled.div`
  flex: 1;
  padding: 0 30px;
  margin-top: 30px;
`;

export const Grid = styled.div`
  display: flex;
  flex: 1;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.direction ? props.direction : 'column')};
  flex-wrap: wrap;
  border-radius: 10px;
  box-shadow: 0 1px 4px 0 rgba(206, 206, 206, 0.5);
  border: solid 1px #ebebeb;
  padding: 15px;
  flex: 1;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 30px;

  ${(props) => props.header
    && css`
      box-shadow: 0 0 4px 0 rgba(62, 196, 184, 0.16);
      border: solid 1px #bbe7e3;
      background-color: #d5f0ed;
    `}

  h1 {
    font-family: Lato;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;

    span {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export const Group = styled.div`
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: calc(33.333%);
  text-align: center;
  margin-bottom: 20px;

  em {
    font-style: normal;
    border: 1px solid #d5f0ed;
    border-radius: 4px;
    display: inline-block;
    background: #d5f0ed;
    padding: 20px;
    min-width: 220px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    span {
      display: block;
    }
  }

`;


export const Count = styled.span`
  font-weight: bold;
`;
